module.exports = __webpack_public_path__ + "assets/img/tit.01f58efd.png";